export default __webpack_public_path__ + "static/media/logo_healthid.ecd025e3.png";